var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-table",
    { staticClass: "fee-schedule-virtual-list", attrs: { selectable: "" } },
    [
      _c(
        "sui-table-header",
        [
          _c(
            "sui-table-row",
            [
              _c("sui-table-header-cell"),
              _vm._l(_vm.columns, function (column, index) {
                return _c("sui-table-header-cell", { key: index }, [
                  _vm._v(" " + _vm._s(column) + " "),
                ])
              }),
              _c("sui-table-header-cell"),
            ],
            2
          ),
        ],
        1
      ),
      _vm.feeSchedules
        ? _c(
            "sui-table-body",
            _vm._l(_vm.feeSchedules, function (schedule, index) {
              return _c(
                "sui-table-row",
                { key: schedule.id },
                [
                  _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                    _vm._v(_vm._s(index + 1)),
                  ]),
                  _c("sui-table-cell", [_vm._v(_vm._s(schedule.name))]),
                  _c("sui-table-cell", [
                    _vm._v(_vm._s(_vm.toDatetime(schedule.created_date))),
                  ]),
                  _c("sui-table-cell", [
                    _vm._v(_vm._s(_vm.toDatetime(schedule.last_modified_date))),
                  ]),
                  _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                    _c(
                      "div",
                      { staticClass: "fee-schedule-menu" },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "fee-schedule-menu-icon eye",
                          attrs: { icon: "eye" },
                          on: {
                            click: function ($event) {
                              return _vm.viewFeeSchedule(_vm.feeSchedule.id)
                            },
                          },
                        }),
                        _c("font-awesome-icon", {
                          staticClass: "fee-schedule-menu-icon pencil-alt",
                          attrs: { icon: "pencil-alt" },
                          on: {
                            click: function ($event) {
                              return _vm.editFeeSchedule(_vm.feeSchedule.id)
                            },
                          },
                        }),
                        _c("font-awesome-icon", {
                          staticClass: "fee-schedule-menu-icon trash",
                          attrs: { icon: "trash-alt" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteFeeSchedule(_vm.feeSchedule)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            }),
            1
          )
        : _c("div", [_c("p", [_vm._v("No fee schedule(s) found.")])]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }